import * as yup from 'yup';

export const forgotPasswordSchema = yup.object().shape({
  email: yup.string()
      .required('Email or Registration Number is required')
      .test(
        'email-or-username',
        'Enter a valid Email or Registration Number',
        (value) => {
          if (!value) return false;
  
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
          // only treat as email if it has @ and a dot after it (real email pattern)
          const looksLikeEmail =
            value.includes('@') &&
            value.substring(value.indexOf('@')).includes('.');
  
          if (looksLikeEmail) {
            return emailRegex.test(value);
          }
  
          // allow usernames like abc@, student@12, REG123
          return true;
        }
      ),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters')
    .max(50, 'Password must be at most 50 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&^()_+=-]).*$/,
      'Use: uppercase, lowercase, number & symbol'
    ),
});

export const verifyOtpSchema = yup.object().shape({
  otp: yup
    .string()
    .required('Required')
    .min(6, 'OTP must be 6 digits')
    .max(6, 'OTP must be 6 digits'),
});

export const whatsAppSettingSchema = yup.object().shape({
  token: yup
    .string()
    .required('Token is required'),
   phoneNumberId: yup
    .string()
    .required('Phone number is required')
    .matches(/^\d+$/, 'Phone number must contain only numbers'),
});